import BaseRequestEditorMixin from "@/modules/core/request/protected/BaseRequestEditorMixin";
import service from "./MicroCreditRequestService";
import RequestForm from "./MicroCreditRequestForm";

export default {
  mixins: [BaseRequestEditorMixin],

  created() {
    this.RequestForm = RequestForm;
    this.requestContextServerPath = "micro-credit/requests";
    //this.externalContext = 'MICRO_CREDIT_REQUEST';
  },

  methods: {
    getService() {
      return service;
    }
  }
};
